import React from 'react';
import { ThemeProvider } from "styled-components";
import App from "./Components/App/App";
import theme from './theme';
function Root() {
  return (
    <div>
       <ThemeProvider theme={theme}>
           <App/>
        </ThemeProvider>
    </div>
  );
}

export default Root;
